import React, { useState } from 'react';
import '../styles/Home.css';
import SearchBar from '../components/SearchBar';
import FeatureCard from '../components/FeatureCard';
import BetaSignupModal from '../components/BetaSignupModal';
import SuccessModal from '../components/SuccessModal';

function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const handleBetaSignup = () => {
    setIsModalOpen(true);
  };

  const features = [
    {
      title: "AI-Powered Insights",
      description: "Advanced machine learning algorithms analyze property data to provide accurate valuations and market trends.",
      icon: "🤖"
    },
    {
      title: "Comprehensive Data",
      description: "Access detailed property information, ownership history, and market analytics in real-time.",
      icon: "📊"
    },
    {
      title: "Smart Predictions",
      description: "Get future property value predictions and investment opportunities using AI technology.",
      icon: "📈"
    }
  ];

  return (
    <div className="home">
      <div className="hero-section">
        <h1>Discover Properties Smarter</h1>
        <p className="hero-subtitle">AI-powered real estate intelligence for informed property decisions</p>
        <SearchBar onSearch={handleBetaSignup} />
      </div>

      <section className="features-section">
        <h2>Why Choose PropScan AI</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
            />
          ))}
        </div>
      </section>

      <section className="cta-section">
        <h2>Start Your Property Search Today</h2>
        <p>Join thousands of real estate professionals using PropScan AI</p>
        <button onClick={handleBetaSignup} className="cta-button">Get Started Free</button>
      </section>

      <BetaSignupModal 
        isOpen={isModalOpen} 
        onClose={() => {
          setIsModalOpen(false);
          setIsSuccessModalOpen(true);
        }} 
      />
      <SuccessModal 
        isOpen={isSuccessModalOpen} 
        onClose={() => setIsSuccessModalOpen(false)} 
      />
    </div>
  );
}

export default Home; 